import { instance } from "../axios";

export const getPatientByCenter = async (centerId) => {
    const response = await instance.get(`/patient/center/${centerId}`);
  return response.data;
};

export const createPatient = async (patient) => {
  const response = await instance.post("/patient", patient);
  return response.data;
};

export const updatePatient = async (patientId, patient) => {
  const response = await instance.put(`/patient/${patientId}`, patient);
  return response.data;
};
